var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "train" } },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.toptab,
            callback: function($$v) {
              _vm.toptab = $$v
            },
            expression: "toptab"
          }
        },
        _vm._l(_vm.loneTab, function(item, index) {
          return _c("el-tab-pane", { key: index, attrs: { name: item.name } }, [
            _c("span", { attrs: { slot: "label" }, slot: "label" }, [
              _vm._v(_vm._s(item.name))
            ])
          ])
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "voice" }, [
        _c(
          "div",
          { staticClass: "tabBox" },
          _vm._l(_vm.tabList, function(t, key) {
            return _c(
              "div",
              {
                key: key,
                staticClass: "index_tabBox",
                class: {
                  index_tabBox_after: key == _vm.tabIndex,
                  index_tabBox_left: key != 0,
                  index_tabbox_0: key == 0,
                  index_tabbox_last: key == _vm.loneTab.length - 1
                },
                on: {
                  click: function($event) {
                    return _vm.changeSecondaryTab(key, t.categoryId, t)
                  }
                }
              },
              [_vm._v("\n         " + _vm._s(t.categoryName) + "\n       ")]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _vm.newPeopleBadgeId == false
              ? _c(
                  "div",
                  [
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "注意",
                          visible: _vm.dialogVisible,
                          width: "30%",
                          "show-close": false,
                          "close-on-click-modal": false
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.dialogVisible = $event
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v("完成前面的《系统测试》，才能报名技能提升培训")
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.dialogVisible = false
                                  }
                                }
                              },
                              [_vm._v("确 定")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.assitantType != "VoiceUpgradeSkill"
              ? _vm._l(_vm.courseList, function(c, key) {
                  return _c("div", { key: key, staticClass: "step-list" }, [
                    _c(
                      "div",
                      {
                        class: {
                          step: true,
                          active: c.passState == "Passed",
                          progress:
                            c.passState == "Ongoing" || c.passState == null
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "circle",
                            class: {
                              circle: c.passState == "Passed",
                              othercircle:
                                c.passState == "Ongoing" || c.passState == null
                            }
                          },
                          [
                            _vm.courseList.length != 1
                              ? _c("div", [_vm._v(_vm._s(key + 1))])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        key != 0
                          ? _c("div", {
                              staticClass: "top_line",
                              class: {
                                top_isCheck:
                                  c.passState == "Passed" ||
                                  c.passState == "Ongoing"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        key != _vm.courseList.length - 1
                          ? _c("div", {
                              class: {
                                line: c.passState == "Passed",
                                otherline:
                                  c.passState == "Ongoing" ||
                                  c.passState == null
                              }
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c("div", { staticClass: "box boxstyle" }, [
                        _c(
                          "div",
                          { staticClass: "title" },
                          [
                            _c("div", [
                              _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(c.courseName))
                              ])
                            ]),
                            _vm._v(" "),
                            c.unlock
                              ? [
                                  _c(
                                    "div",
                                    {
                                      class:
                                        c.passState == "Passed"
                                          ? "isgreen"
                                          : "isred"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          c.passState == "Passed"
                                            ? "已完成"
                                            : "未完成"
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "test-button isposition",
                                      on: {
                                        click: function($event) {
                                          return _vm.toStudy(
                                            c.courseId,
                                            c.unlock,
                                            c.courseType,
                                            c,
                                            c.status
                                          )
                                        }
                                      }
                                    },
                                    [
                                      (c.assitantType == null ||
                                        c.assitantType == "") &&
                                      c.courseType == "Integrate" &&
                                      c.passState != "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small"
                                              }
                                            },
                                            [_vm._v("点击学习")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (c.assitantType == null ||
                                        c.assitantType == "") &&
                                      c.courseType == "Integrate" &&
                                      c.passState == "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small"
                                              }
                                            },
                                            [_vm._v("重新学习")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (c.assitantType == null ||
                                        c.assitantType == "") &&
                                      c.courseType == "Exam" &&
                                      c.passState != "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small"
                                              }
                                            },
                                            [_vm._v("开始测试")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (c.assitantType == null ||
                                        c.assitantType == "") &&
                                      c.courseType == "Exam" &&
                                      c.passState == "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small"
                                              }
                                            },
                                            [_vm._v("重新测试")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      c.assitantType ==
                                        "AssitantSpecialRobotExam" &&
                                      c.retry == "false" &&
                                      c.passState != "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "primary"
                                              }
                                            },
                                            [_vm._v("开始测试")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      c.assitantType ==
                                        "AssitantSpecialRobotExam" &&
                                      c.retry == "true" &&
                                      c.passState != "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "primary"
                                              }
                                            },
                                            [_vm._v("开始测试")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      c.assitantType ==
                                        "AssitantSpecialRobotExam" &&
                                      c.retry == "true" &&
                                      c.passState == "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small"
                                              }
                                            },
                                            [_vm._v("重新测试")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      c.assitantType ==
                                        "AssitantSpecialRobotExam" &&
                                      c.retry == "false" &&
                                      c.passState == "Passed"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small"
                                              }
                                            },
                                            [_vm._v("重新测试")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              : [_c("div", { staticClass: "lock" })]
                          ],
                          2
                        ),
                        _vm._v(" "),
                        c.courseType == "Integrate"
                          ? _c("div", { staticClass: "text textstyle" }, [
                              _vm._v(
                                "\n                 课程说明：\n                 "
                              ),
                              _c("div", { staticStyle: { width: "70%" } }, [
                                _vm._v(_vm._s(c.description)),
                                c.result != null
                                  ? _c("span", { staticClass: "thespan" }, [
                                      _vm._v("(" + _vm._s(c.result) + ")")
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        c.courseType == "Exam"
                          ? _c("div", { staticClass: "text textstyle" }, [
                              _vm._v(
                                "完成要求：" +
                                  _vm._s(c.description) +
                                  "\n               "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ])
                })
              : [
                  _vm._l(_vm.cseList, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "RegistrationSessions" },
                      [
                        _c("div", { staticClass: "text_box" }, [
                          _c("div", { staticClass: "title_state_button" }, [
                            _c("div", { staticClass: "title_state" }, [
                              _vm._v(
                                "\n       " +
                                  _vm._s(item.trainTitle) +
                                  "\n       "
                              ),
                              _vm._v(" "),
                              item.passState != "signTimeOut"
                                ? _c(
                                    "div",
                                    {
                                      class: {
                                        Reg_isred:
                                          item.passState != "passed" &&
                                          item.passState != "signTimeOut",
                                        Reg_isgreen: item.passState == "passed"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n        " +
                                          _vm._s(
                                            item.passState != "passed" &&
                                              item.passState != "signTimeOut"
                                              ? "未完成"
                                              : "已完成"
                                          ) +
                                          "\n       "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            item.passState == "noJoin"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "Reg_button",
                                    on: {
                                      click: function($event) {
                                        return _vm.goscene(
                                          item.sceneId,
                                          item.trainId
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("点击报名")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.passState != "noJoin" &&
                            item.passState != "passed" &&
                            item.passState != "noSignAlreadyOpen" &&
                            item.passState != "noSignedNoOpen" &&
                            item.passState != "signTimeOut"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "Reg_button",
                                    on: {
                                      click: function($event) {
                                        return _vm.regoscene(
                                          item.sceneId,
                                          item.trainId
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("点击学习")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.passState == "passed"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "Reg_button",
                                    on: {
                                      click: function($event) {
                                        return _vm.regoscene(
                                          item.sceneId,
                                          item.trainId
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("重新学习")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.passState == "noSignAlreadyOpen"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "Reg_button",
                                    on: {
                                      click: function($event) {
                                        return _vm.signIn(item.trainId)
                                      }
                                    }
                                  },
                                  [_vm._v("点击签到")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.passState == "noSignedNoOpen"
                              ? _c(
                                  "div",
                                  { staticClass: "Reg_button_noqian" },
                                  [_vm._v("点击签到")]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "Reg_date" }, [
                            _vm._v(
                              "\n      " + _vm._s(item.trainDate) + "\n    "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "Reg_time" },
                            _vm._l(item.trainTime, function(m, key) {
                              return _c("span", { key: key }, [
                                _vm._v(_vm._s(m)),
                                key < item.trainTime.length - 1
                                  ? _c("span", [_vm._v("，")])
                                  : _vm._e()
                              ])
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "Reg_lecturer" }, [
                            _vm._v(
                              "\n      培训讲师：" +
                                _vm._s(item.teacherName) +
                                "\n    "
                            )
                          ]),
                          _vm._v(" "),
                          item.passState != "passed" &&
                          item.passState != "signTimeOut" &&
                          item.passState1 != "noJoin"
                            ? _c("div", { staticClass: "Reg_qq" }, [
                                _vm._v("\n      培训QQ群： 793655472\n    ")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "Reg_content" }, [
                            _vm._v("培训内容：" + _vm._s(item.trainContent))
                          ]),
                          _vm._v(" "),
                          item.passState == "signTimeOut"
                            ? _c("div", { staticClass: "fail_img" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("../../../assets/images/fail.png"),
                                    alt: ""
                                  }
                                }),
                                _c("div", { staticClass: "fail_text" }, [
                                  _vm._v("已失效")
                                ])
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: "",
                        visible: _vm.enlist,
                        width: "360px",
                        "show-close": false,
                        "close-on-click-modal": false
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.enlist = $event
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "dialog_img" }, [
                        _c("img", {
                          attrs: {
                            src: require("../../../assets/images/voiceScene/icon_tips.png"),
                            alt: ""
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "qq_text" }, [
                        _vm._v("确认参加培训并加入培训群")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c("div", { staticClass: "currency_button" }, [
                            _c(
                              "div",
                              {
                                staticClass: "cancel",
                                on: {
                                  click: function($event) {
                                    _vm.enlist = false
                                  }
                                }
                              },
                              [_vm._v("\n            取消\n          ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "determine",
                                on: { click: _vm.isenlist }
                              },
                              [_vm._v("\n            确定\n          ")]
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: "",
                        visible: _vm.dimensional,
                        width: "360px",
                        "close-on-click-modal": false,
                        center: ""
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dimensional = $event
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "dimensionalimg_Line" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "dimensionalimg" }, [
                        _c("img", {
                          attrs: { src: _vm.dimensionalimg, alt: "" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dimensionalimg_text" }, [
                        _vm._v("请使用手机QQ扫一扫加入培训群")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cel-button",
                              on: { click: _vm.qqsceneId }
                            },
                            [_vm._v("已扫码加入")]
                          )
                        ]
                      )
                    ]
                  )
                ],
            _vm._v(" "),
            [
              [
                [
                  _c("p", { staticClass: "description" }, [
                    _vm._v(_vm._s(_vm.description))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.sceneList, function(s, key) {
                    return _c("div", { staticClass: "scene" }, [
                      _c("img", { attrs: { src: s.imageUrl } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "box" }, [
                        _c("div", { staticClass: "title title_style" }, [
                          _c("div", [
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(s.name))
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: {
                                blue: true,
                                green: s.status == "Finish",
                                colorstylr: true
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    s.status == "Finish" ? "已完成" : "未完成"
                                  )
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text" }, [
                          _c("div", { staticStyle: { width: "70%" } }, [
                            _vm._v(
                              "课程说明：\n                     " +
                                _vm._s(s.description)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "status",
                            on: {
                              click: function($event) {
                                return _vm.toCourseList(s.id)
                              }
                            }
                          },
                          [_vm._v("点击进入")]
                        )
                      ])
                    ])
                  })
                ]
              ]
            ]
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-465d3ac2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-465d3ac2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/newservice/Knowledge.vue
// module id = 1634
// module chunks = 0